import { render, staticRenderFns } from "./typography.vue?vue&type=template&id=4f6609b8&lang=html&"
import script from "./typography.vue?vue&type=script&lang=js&"
export * from "./typography.vue?vue&type=script&lang=js&"
import style0 from "./typography.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../rubis-bi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports